import { useEffect, useState } from 'react';
import { api, formatPKR } from '../api';
import PageHeader from '../components/PageHeader';

export default function StockBatches() {
  const [batches, setBatches] = useState([]);
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({
    productName: '',
    quantity: '',
    costPerUnit: '',
    batchDate: new Date().toISOString().split('T')[0],
  });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const load = () => {
    api.getStockBatches().then(setBatches);
    api.getProducts().then(setProducts);
  };

  useEffect(() => {
    load();
  }, []);

  const totalCost =
    form.quantity && form.costPerUnit
      ? Number(form.quantity) * Number(form.costPerUnit)
      : 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      await api.addStockBatch({
        productName: form.productName,
        quantity: Number(form.quantity),
        costPerUnit: Number(form.costPerUnit),
        batchDate: form.batchDate,
      });
      setMessage('Stock batch saved');
      setForm({ ...form, quantity: '', costPerUnit: '' });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <PageHeader title="Stock Batches" subtitle="Track inventory purchases and costs" />
      <div className="grid lg:grid-cols-2 gap-8">
        <form onSubmit={handleSubmit} className="card space-y-4">
          <h3 className="font-serif font-medium text-lumora-dark-wood">Add Stock Batch</h3>
          <select
            value={form.productName}
            onChange={(e) => setForm({ ...form, productName: e.target.value })}
            className="input"
            required
          >
            <option value="">Product Name</option>
            {products
              .filter((p) => p.active)
              .map((p) => (
                <option key={p.id} value={p.name}>
                  {p.name}
                </option>
              ))}
          </select>
          <input
            type="number"
            min="1"
            placeholder="Quantity Purchased"
            value={form.quantity}
            onChange={(e) => setForm({ ...form, quantity: e.target.value })}
            className="input"
            required
          />
          <input
            type="number"
            min="0"
            step="0.01"
            placeholder="Cost Per Unit"
            value={form.costPerUnit}
            onChange={(e) => setForm({ ...form, costPerUnit: e.target.value })}
            className="input"
            required
          />
          <div className="text-sm text-lumora-text/60">
            Total Batch Cost: <span className="text-lumora-wood font-medium">{formatPKR(totalCost)}</span>
          </div>
          <input
            type="date"
            value={form.batchDate}
            onChange={(e) => setForm({ ...form, batchDate: e.target.value })}
            className="input"
            required
          />
          {error && <p className="text-red-600 text-sm">{error}</p>}
          {message && <p className="text-green-700 text-sm">{message}</p>}
          <button type="submit" className="btn-primary">
            Save Batch
          </button>
        </form>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Product</th>
                <th>Qty</th>
                <th>Cost/Unit</th>
                <th>Total</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {batches.map((b) => (
                <tr key={b.id}>
                  <td>{b.id}</td>
                  <td>{b.productName}</td>
                  <td>{b.quantity}</td>
                  <td>{formatPKR(b.costPerUnit)}</td>
                  <td>{formatPKR(b.totalCost)}</td>
                  <td>{b.batchDate}</td>
                </tr>
              ))}
              {batches.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-lumora-text/50 py-8">
                    No batches yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
